// import ParticipantService from '../services/ParticipantDataService';

export const participant = {
  namespaced: true,
  state: {
    selectedParticipantId: null,
  },
  actions: {
    setSelectedParticipantId({ commit }, participant_id) {
      commit('SET_SELECTED_PARTICIPANT_ID', participant_id);
    },
    setParticipantCompetitions({ commit }, participantCompetitions) {
      commit('SET_PARTICIPANT_COMPETITIONS', participantCompetitions);
    }
  },
  mutations: {
    SET_SELECTED_PARTICIPANT_ID(state, participant_id) {
      state.selectedParticipantId = participant_id;
    },
    SET_PARTICIPANT_COMPETITIONS(state, participantCompetitions) {
      state.participantCompetitions = participantCompetitions;
    }
  },
};
